(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ph-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ph-bundle')) {
    customElements.define('ph-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.money = new Intl.NumberFormat(this.dataset.locale, {style: 'currency', currency: this.dataset.currency});
        this.button = this.querySelector('.ph-bundle__submit');
        this.message = this.querySelector('.ph-bundle__message');
        this.addEventListener('change', () => this.update());
        this.button.addEventListener('click', () => this.add());
        this.update();
      }
      selections(offer) {
        return Array.from(offer.querySelectorAll('select')).map(select => this.variants.find(variant => String(variant.id) === select.value));
      }
      update() {
        const active = this.querySelector('.ph-bundle__radio:checked').closest('.ph-bundle__offer');
        for (const offer of this.querySelectorAll('.ph-bundle__offer')) {
          const selected = offer === active;
          offer.querySelector('.ph-bundle__choices').hidden = !selected;
          offer.querySelectorAll('select').forEach(select => { select.disabled = !selected; });
          const variants = this.selections(offer);
          const compare = variants.reduce((sum, variant) => sum + Math.max(variant?.compare_at_price || 0, variant?.price || 0), 0);
          const price = variants.reduce((sum, variant) => sum + Math.round((variant?.price || 0) * (100 - Number(offer.dataset.rate)) / 100), 0);
          offer.querySelector('[data-total]').textContent = this.money.format(price / 100);
          offer.querySelector('[data-compare]').textContent = this.money.format(compare / 100);
          offer.querySelector('[data-compare]').hidden = compare <= price;
          if (selected) this.button.disabled = this.pending || variants.some(variant => !variant?.available);
        }
      }
      async add() {
        if (this.pending || this.button.disabled) return;
        const active = this.querySelector('.ph-bundle__radio:checked').closest('.ph-bundle__offer');
        const itemsById = new Map();
        for (const variant of this.selections(active)) {
          if (!variant?.available) return;
          const item = itemsById.get(variant.id) || {id: variant.id, quantity: 0};
          item.quantity += 1;
          itemsById.set(variant.id, item);
        }
        this.pending = true;
        this.button.disabled = true;
        this.querySelectorAll('input, select').forEach(control => { control.disabled = true; });
        this.message.textContent = '';
        try {
          const response = await fetch(this.dataset.add, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: Array.from(itemsById.values())})});
          if (!response.ok) {
            this.message.textContent = this.dataset.error;
            this.message.append(' ');
            const link = document.createElement('a');
            link.href = this.dataset.cart;
            link.textContent = this.dataset.viewCart;
            this.message.append(link);
            return;
          }
          window.location.assign(this.dataset.cart);
        } catch {
          this.message.textContent = this.dataset.error;
        } finally {
          this.pending = false;
          this.querySelectorAll('input').forEach(control => { control.disabled = false; });
          this.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
